import { request } from '@/helpers';
import Faq from 'src/logic/models/catalogue/Faq';

export const getCategoryFaqs = (categoryId: number): Promise<{ data: Faq[] }> => {
  return request({
    url: `/categories/${categoryId}/faqs`,
    method: 'GET',
  });
};
